import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import ResetPasswordPage from "./components/Auth/ResetPasswordPage";
import NavBar from "./components/Home/NavBar";
import SupaLogin from "./components/Login/SupaLogin";
import { Homepage } from "./components/Homepage/Homepage";
import PerlinNoise from "./components/Processing/PerlinNoise";
import Fibonacci from "./components/Processing/Fibonacci/Fibonacci";
import { Retro } from "./components/Retro/Retro";
import ManagePage from "./components/ManagePage/ManagePage";
import ManageEditor from "./components/ManagePage/ManageEditor";
import BlogWrapper from "./components/Blog/BlogWrapper";
import { BlogProvider } from "./context/BlogContext";
import './App.css';



const App = () => {
    return (
        <div className="min-width-scroll">
            <Routes>
                <Route path="*" element={<Navigate to="/home" replace />} />
                <Route path='/home' element={<><Homepage /></>} />
                <Route path='/login' element={<><NavBar /> <SupaLogin /> </>} />
                <Route path='/processing/perlinNoise' element={<><NavBar /> <PerlinNoise /> </>} />
                <Route path='/processing/fibonacci' element={<><NavBar /> <Fibonacci /> </>} />
                <Route path='/profile/passwordReset' element={<ProtectedRoute> <ResetPasswordPage /> </ProtectedRoute>} />
                <Route path='/retro' element={<> <NavBar /> <Retro /></>} />
                <Route path='/manage' element={<BlogProvider><ManagePage /></BlogProvider>} />
                <Route path='/manage/edit/:id' element={<BlogProvider><ManageEditor /></BlogProvider>} />
                <Route path='/blog/*' element={<BlogWrapper />} />
            </Routes>
        </div>
    )
}

export default App;